import { render, staticRenderFns } from "./WriterTypeIndicatorSkipConfirmDialog.vue?vue&type=template&id=270e22bc&scoped=true"
import script from "./WriterTypeIndicatorSkipConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./WriterTypeIndicatorSkipConfirmDialog.vue?vue&type=script&lang=ts"
import style0 from "./WriterTypeIndicatorSkipConfirmDialog.vue?vue&type=style&index=0&id=270e22bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270e22bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('270e22bc')) {
      api.createRecord('270e22bc', component.options)
    } else {
      api.reload('270e22bc', component.options)
    }
    module.hot.accept("./WriterTypeIndicatorSkipConfirmDialog.vue?vue&type=template&id=270e22bc&scoped=true", function () {
      api.rerender('270e22bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/WriterTypeIndicatorSkipConfirmDialog.vue"
export default component.exports